import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

export const RowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const InputContainer = styled.div`
  flex: 1;
  padding: 8px 12px 8px 0;
`;

export const SelectContainer = styled.div`
  flex: 0 0 160px;
  padding: 8px 12px 8px 0;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const CancelButton = styled.button`
  width: 142px;
  height: 33px;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  border-radius: 8px;
  border: none;
  color: #dc3545;
  background: transparent;
  transition: all 0.2s ease;
  box-shadow: inset 0 0 0 1px #dc3545;

  &:hover {
    background: #dc3545;
    color: white;
  }
`;
